<template>
  <svg
    class="icon icon-vue-dot-js"
    xmlns="http://www.w3.org/2000/svg"
    baseProfile="tiny"
    version="1.2"
    viewBox="0 0 32 32"
    :width="width"
    :height="width"
  >
    <title>vue-dot-js</title>
    <path d="M25.596 2.144l0.004-0.008h-5.9l-3.7 6.4-3.696-6.4h-5.9v0.007h-6.404l16 27.715 16-27.713z"></path>
  </svg>
</template>

<script>
export default {
  name: 'vue',
  props: {
    width: {
      type: Number,
      default: 50,
      required: false
    }
  }
}
</script>